var render = function render(){var _vm=this,_c=_vm._self._c;return _c('dropdown-selector',{attrs:{"value":_vm.value,"options":_vm.messageboxes,"keys":{ label: 'name', colour: 'colour' },"disabled":_vm.disabled},on:{"input":_vm.input}})
}
var staticRenderFns = []

export { render, staticRenderFns }